import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./header.css";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = Boolean(localStorage.getItem("authenticatedProfileId"));

  const toggleMenu = () => setIsOpen(!isOpen);
  const hideLoginLink = location.pathname === "/auth" || location.pathname === "/login";
  const scrollToFooter = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleContactClick = (event) => {
    event.preventDefault();
    setIsOpen(false);

    if (location.pathname === "/") {
      scrollToFooter();
      return;
    }

    sessionStorage.setItem("scrollToFooter", "true");
    navigate("/");
  };

  const handleLogout = () => {
    localStorage.removeItem("authenticatedProfileId");
    setIsOpen(false);
    navigate("/");
  };

  return (
    <header className="header">
      <div className="header-top">
        
      <a className="" href="/#hero">
      <div className="logo">
        <img src="/logo512.jpeg" alt="Luna Plane logo" />
      </div>
        </a>
        {!hideLoginLink && (
           <button className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        )
        }
      </div>

      <nav className={`nav ${isOpen ? "open" : ""}`}>
        <ul className="nav-list">
          {!hideLoginLink && (
            <li>
              <Link
                to={isAuthenticated ? "/home" : "/login"}
                onClick={() => setIsOpen(false)}
                className="login-link"
                aria-label={isAuthenticated ? "Profile" : "Login"}
              >
                <span className="login-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="8" r="4"></circle>
                    <path d="M4 20c1.8-3.5 5-5.2 8-5.2s6.2 1.7 8 5.2"></path>
                  </svg>
                </span>
                {!isAuthenticated ? "LogIn" : null}
              </Link>
            </li>
          )}
          {!hideLoginLink && isAuthenticated && (
            <li>
              <button
                type="button"
                onClick={handleLogout}
                className="logout-button"
              >
                Logout
              </button>
            </li>
          )}
           {!hideLoginLink &&( <li>
              <a href="#footer" onClick={handleContactClick} className="login-link">
                Contact
              </a>
            </li>)

           }
           
        </ul>
      </nav>

      {/* overlay */}
      <div
        className={`overlay ${isOpen ? "show" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>
    </header>
  );
};

export default Header;
